import { convert } from 'twemoji';

const base = '/assets/twemoji/';

const size = 'svg';
const ext = 'svg';

// https://github.com/twitter/twemoji/blob/gh-pages/2/twemoji.js
export function imgSrcForEmojiHex(hex: string) {
  // SVG: https://twemoji.maxcdn.com/2/svg/1f004.svg
  // PNG: https://twemoji.maxcdn.com/2/72x72/1f004.png
  return `${base}${size}/${hex}.${ext}`;
}

export function imgSrcForUnicodeEmoji(char: string) {
  const hex = grabTheRightIcon(char);
  return imgSrcForEmojiHex(hex);
}

// COPIED from Twemoji to fix https://github.com/twitter/twemoji/pull/162
const UFE0Fg = /\uFE0F/g;
// avoid using a string literal like '\u200D' here because minifiers expand it inline
const U200D = String.fromCharCode(0x200d);
/**
 * Used to both remove the possible variant
 *  and to convert utf16 into code points.
 *  If there is a zero-width-joiner (U+200D), leave the variants in.
 * @param   string    the raw text of the emoji match
 */
function grabTheRightIcon(rawText: string) {
  // if variant is present as \uFE0F
  return convert.toCodePoint(rawText.indexOf(U200D) < 0 ? rawText.replace(UFE0Fg, '') : rawText);
}

export { replace } from 'twemoji';
